export const texts = [
  'заниматься продажами и рекламой продукта!\n Он сам рекламирует свои возможности!',
  'думать о графике!\n Решай сам, сколько тебе тратить времени!',
  'волноваться о ЗП!\n Все прозрачно и ты видишь свой доход в личном кабинете',
  'общаться с клиентом, после того, как ты пригласил его',
  'волноваться о знаниях!\n все очень просто! Мы всему научим!',
];
